@import url("https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&family=Space+Grotesk:wght@500;600;700&display=swap");

:root {
  color-scheme: dark;
  font-family: "Space Grotesk", system-ui, sans-serif;
  color: #eaf9f5;
  background: #071116;
  font-synthesis: none;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  min-width: 320px;
  min-height: 100vh;
  background:
    radial-gradient(circle at 14% 8%, rgba(53, 151, 154, .15), transparent 29rem),
    #071116;
}

a {
  color: inherit;
}

button {
  font: inherit;
}

.page-shell {
  width: min(100% - 32px, 980px);
  margin: 0 auto;
  padding-bottom: 44px;
}

.topbar {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  border-bottom: 1px solid #1b3036;
  font-family: "DM Mono", monospace;
  font-size: .76rem;
}

.topbar a {
  text-decoration: none;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
}

.brand > span {
  display: grid;
  width: 29px;
  height: 29px;
  place-items: center;
  border-radius: 8px;
  background: #66f2ce;
  color: #071116;
  font-size: .66rem;
}

.topbar nav {
  display: flex;
  gap: 8px;
  color: #78939a;
}

.topbar nav a:hover {
  color: #eaf9f5;
}

.title-row {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 40px;
  padding: 34px 0 24px;
}

.kicker {
  margin: 0 0 7px;
  color: #66f2ce;
  font-family: "DM Mono", monospace;
  font-size: .69rem;
  letter-spacing: .11em;
  text-transform: uppercase;
}

h1, h2, p {
  margin-top: 0;
}

h1 {
  margin-bottom: 0;
  font-size: clamp(2.25rem, 6vw, 4.5rem);
  line-height: .9;
  letter-spacing: -.06em;
}

h1 span {
  color: #66f2ce;
}

.title-row > p {
  max-width: 310px;
  margin-bottom: 0;
  color: #92a9ae;
  font-size: .92rem;
  line-height: 1.5;
}

.game-card {
  overflow: hidden;
  border: 1px solid #264149;
  border-radius: 18px;
  background: #0b191e;
  box-shadow: 0 26px 70px rgba(0, 0, 0, .28);
}

.hud {
  min-height: 62px;
  display: grid;
  grid-template-columns: 1fr 1fr 2fr 1fr 1.25fr;
  align-items: center;
  padding: 9px 18px;
  border-bottom: 1px solid #20363d;
  font-family: "DM Mono", monospace;
}

.hud > div {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.hud span {
  color: #718b92;
  font-size: .62rem;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.hud strong {
  font-size: 1rem;
  font-weight: 500;
}

#game-status {
  margin: 0;
  color: #66f2ce;
  font-size: .7rem;
  text-align: center;
  text-transform: uppercase;
}

#lives {
  color: #66f2ce;
  letter-spacing: .13em;
  white-space: nowrap;
}

.canvas-frame {
  position: relative;
  display: grid;
  place-items: center;
  padding: 16px;
  background:
    linear-gradient(rgba(28, 58, 63, .22) 1px, transparent 1px),
    linear-gradient(90deg, rgba(28, 58, 63, .22) 1px, transparent 1px),
    #061014;
  background-size: 28px 28px;
}

#game {
  width: min(100%, 700px);
  aspect-ratio: 25 / 21;
}

#game canvas {
  display: block;
  width: 100% !important;
  height: 100% !important;
  border-radius: 8px;
}

.notice {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 2;
  transform: translate(-50%, -50%);
  padding: 14px 20px;
  border: 1px solid rgba(102, 242, 206, .55);
  border-radius: 10px;
  background: rgba(7, 17, 22, .92);
  color: #fff;
  box-shadow: 0 14px 40px rgba(0, 0, 0, .36);
  font-family: "DM Mono", monospace;
  font-size: .8rem;
  letter-spacing: .07em;
  text-align: center;
  text-transform: uppercase;
}

.control-row {
  min-height: 82px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 11px 18px;
  border-top: 1px solid #20363d;
}

.d-pad {
  display: grid;
  grid-template-columns: repeat(3, 38px);
  grid-template-rows: repeat(2, 32px);
  gap: 4px;
}

.d-pad button,
.actions button {
  border: 1px solid #2a4b53;
  border-radius: 7px;
  background: #10242a;
  color: #cfe7e3;
  cursor: pointer;
}

.d-pad button:hover,
.d-pad button:active,
.actions button:hover {
  border-color: #66f2ce;
  color: #66f2ce;
}

.d-pad button[data-direction="up"] {
  grid-column: 2;
}

.d-pad button[data-direction="left"] {
  grid-column: 1;
}

.d-pad button[data-direction="down"] {
  grid-column: 2;
}

.d-pad button[data-direction="right"] {
  grid-column: 3;
}

.actions {
  display: flex;
  align-items: center;
  gap: 14px;
  color: #718b92;
  font-family: "DM Mono", monospace;
  font-size: .66rem;
}

.actions button {
  min-width: 82px;
  padding: 9px 13px;
}

.virus-key {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  padding-top: 12px;
}

.virus-key > div {
  display: grid;
  grid-template-columns: 13px 1fr;
  column-gap: 8px;
  padding: 10px 12px;
  border: 1px solid #182d33;
  border-radius: 9px;
  color: #8ca3a8;
  font-size: .71rem;
}

.virus-key i {
  grid-row: 1 / 3;
  width: 10px;
  height: 10px;
  margin-top: 3px;
  border-radius: 50%;
}

.virus-key strong {
  color: #d9ebe8;
  font-size: .72rem;
  font-weight: 600;
}

.virus-key span {
  font-family: "DM Mono", monospace;
  font-size: .6rem;
}

.worm { background: #ff5e6c; }
.trojan { background: #ffae57; }
.spyware { background: #bd72f5; }
.bot { background: #4fd5e7; }

.game-dialog {
  width: min(90vw, 440px);
  padding: 30px;
  border: 1px solid #31545d;
  border-radius: 17px;
  background: #0b191e;
  color: #eaf9f5;
  box-shadow: 0 28px 100px #000;
  text-align: center;
}

.game-dialog::backdrop {
  background: rgba(2, 8, 10, .76);
  backdrop-filter: blur(4px);
}

.game-dialog h2 {
  margin-bottom: 10px;
  font-size: 2rem;
  letter-spacing: -.04em;
}

.game-dialog > p:not(.kicker) {
  color: #9ab0b5;
  line-height: 1.55;
}

.game-dialog > button,
.dialog-actions button {
  padding: 12px 17px;
  border: 0;
  border-radius: 8px;
  background: #66f2ce;
  color: #071116;
  cursor: pointer;
  font-weight: 700;
}

.dialog-byte {
  display: grid;
  width: 52px;
  height: 52px;
  margin: 0 auto 18px;
  place-items: center;
  border-radius: 14px;
  background: #66f2ce;
  color: #071116;
  font-family: "DM Mono", monospace;
  font-size: .9rem;
  font-weight: 700;
}

.dialog-byte.error {
  background: #ff5e6c;
  font-size: 1.5rem;
}

.dialog-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
}

.dialog-actions a {
  color: #94aaaf;
  font-size: .8rem;
}

@media (max-width: 700px) {
  .page-shell {
    width: min(100% - 20px, 980px);
  }

  .topbar {
    min-height: 58px;
  }

  .title-row {
    align-items: start;
    padding: 25px 0 18px;
  }

  .title-row > p {
    max-width: 220px;
    font-size: .78rem;
  }

  .canvas-frame {
    padding: 8px;
  }

  .hud {
    grid-template-columns: repeat(4, 1fr);
    min-height: 57px;
    padding: 7px 10px;
  }

  #game-status {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none;
    opacity: 0;
  }

  .hud > div:nth-of-type(2) {
    display: none;
  }

  .virus-key {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .title-row {
    display: block;
  }

  .title-row > p {
    display: none;
  }

  h1 {
    font-size: 2.65rem;
  }

  .topbar nav span:last-child {
    display: none;
  }

  .game-card {
    border-radius: 12px;
  }

  .control-row {
    padding: 9px 12px;
  }

  .actions > span {
    display: none;
  }

  .d-pad {
    grid-template-columns: repeat(3, 42px);
    grid-template-rows: repeat(2, 35px);
  }
}
